<template>
    <el-dialog
            :title="$store.state.modal.title"
            :visible.sync="$store.state.modal.dialogVisible"
            :width="$store.state.modal.width+'px'"
            :fullscreen="$store.state.modal.fullscreen"
            :before-close="handleClose">

        <compoments :ref="$store.state.modal.componment" :is="$store.state.modal.componment"
                    v-if="$store.state.modal.dialogVisible"></compoments>
    </el-dialog>
</template>

<style>


</style>
<script>
    //学生详情
    import Dialog_ChangeInformation from '@/views/Student/Show/dialogs/Dialog_ChangeInformation';
    import Dialog_ChangeStudentPhone from '@/views/Student/Show/dialogs/Dialog_ChangeStudentPhone';
    //学生详情-课程咨询
    import Dialog_AddAdvisory from '@/views/Student/Show/Advisory/dialogs/Dialog_AddAdvisory';
    import Dialog_ShowAdvisory from '@/views/Student/Show/Advisory/dialogs/Dialog_ShowAdvisory';
    //学生详情-课程记录
    import Dialog_CancelCourse from '@/views/Student/Show/CourseRecording/dialogs/Dialog_CancelCourse';
    import Dialog_ChangeCourse from '@/views/Student/Show/CourseRecording/dialogs/Dialog_ChangeCourse';
    import Dialog_StudentCourseEvaluation
        from '@/views/Student/Show/CourseRecording/dialogs/Dialog_StudentCourseEvaluation';
    //学生详情-课程购买
    import Dialog_ChooseClassPlan from '@/views/Student/Show/Cart/dialogs/Dialog_ChooseClassPlan';
    import Dialog_ChooseSpecialClass from '@/views/Student/Show/Cart/dialogs/Dialog_ChooseSpecialClass';
    import Dialog_ChooseCoupon from '@/views/Student/Show/Cart/dialogs/Dialog_ChooseCoupon';
    import Dialog_ChooseLesson from '@/views/Student/Show/Cart/dialogs/Dialog_ChooseLesson';
    import Dialog_ChooseWanTuoClassPlan from '@/views/Student/Show/Cart/dialogs/Dialog_ChooseWanTuoClassPlan';
    import Dialog_DiscountCourse from '@/views/Student/Show/Cart/dialogs/Dialog_DiscountCourse';
    import Dialog_DiscountType from '@/views/Student/Show/Cart/dialogs/Dialog_DiscountType';
    import Dialog_HasTime from '@/views/Student/Show/Cart/dialogs/Dialog_HasTime';
    import Dialog_ChooseClass from '@/views/Student/Show/Cart/dialogs/Dialog_ChooseClass';
    import Dialog_Installment from '@/views/Student/Show/Cart/dialogs/Dialog_Installment';
    import Dialog_SettleAccounts from '@/views/Student/Show/Cart/dialogs/Dialog_SettleAccounts';
    import Dialog_SettleSuccess from '@/views/Student/Show/Cart/dialogs/Dialog_SettleSuccess';
    //学生详情-购买课时
    import Dialog_ClassHourCart from '@/views/Student/Show/Cart/dialogs/Dialog_ClassHourCart';
    //学生详情-打折课时
    import Dialog_DiscountClassHour from '@/views/Student/Show/Cart/dialogs/Dialog_DiscountClassHour';
    //学生详情-购买商品
    import Dialog_ShopCart from '@/views/Student/Show/Cart/dialogs/Dialog_ShopCart';
    //学生详情-打折商品
    import Dialog_DiscountShop from '@/views/Student/Show/Cart/dialogs/Dialog_DiscountShop';
    //课次，商品结算
    import Dialog_SettleAnotherAccounts from '@/views/Student/Show/Cart/dialogs/Dialog_SettleAnotherAccounts'
    //使用课次
    import Dialog_UseClassHour from '@/views/Student/Show/Cart/dialogs/Dialog_UseClassHour'
    //购物车显示试听
    import Dialog_TryingCart from '@/views/Student/Show/Cart/dialogs/Dialog_TryingCart'
    //学生详情-钱包
    import Dialog_LessonRetired from '@/views/Student/Show/Wallet/dialogs/Dialog_LessonRetired';
    import Dialog_WalletAddCash from '@/views/Student/Show/Wallet/dialogs/Dialog_WalletAddCash';
    import Dialog_BalanceDetail from '@/views/Student/Show/Wallet/dialogs/Dialog_BalanceDetail';
    import Dialog_ClassHourRetired from '@/views/Student/Show/Wallet/dialogs/Dialog_ClassHourRetired';
    import Dialog_UpdateCashCoupon from '@/views/Student/Show/Wallet/dialogs/Dialog_UpdateCashCoupon';
    //学生详情-教育经历
    import Dialog_StudentAddEducationalExperiences
        from '@/views/Student/Show/EducationalExperiences/dialogs/Dialog_StudentAddEducationalExperiences';
    import Dialog_StudentEducationalExperiencesDetail
        from '@/views/Student/Show/EducationalExperiences/dialogs/Dialog_StudentEducationalExperiencesDetail';
    //学生详情-学校成绩
    import Dialog_AddSchoolScore from '@/views/Student/Show/Score/dialogs/Dialog_AddSchoolScore';
    import Dialog_UpdateMainSchoolScore from '@/views/Student/Show/Score/dialogs/Dialog_UpdateMainSchoolScore';
    //学生详情-回访
    import Dialog_PastReturnDetail from '@/views/Student/Show/ReturnVisit/dialogs/Dialog_PastReturnDetail';
    //学生详情-在读课程概况
    import Dialog_ChangeClassPlan from '@/views/Student/Show/StudentPeriod/dialogs/Dialog_ChangeClassPlan';
    //学生详情-周课表
    import Dialog_StudentWeekTable from '@/views/Student/TimeTable/Week/OperationWeek';
    //学生详情-月课表
    import Dialog_StudentMonthTable from '@/views/Student/TimeTable/Month/OperationMonth';
    //未结算合同-订单详情
    import Dialog_SettlementInvoiceDetail from '@/views/Student/Show/NoSettlementInvoice/dialogs/Dialog_SettlementInvoiceDetail';

    //课表
    import Dialog_UpdateClass from '@/views/TimeTable/Daily/dialogs/Dialog_UpdateClass';
    import Dialog_CreateClass_Semester from '@/views/TimeTable/Semester/dialogs/Dialog_CreateClass_Semester';
    import Dialog_UpdateClass_Semester from '@/views/TimeTable/Semester/dialogs/Dialog_UpdateClass_Semester';
    import Dialog_TableSiteModal from '@/views/TimeTable/Semester/dialogs/Dialog_TableSiteModal';
    import Dialog_TimeTableExcel from '@/views/TimeTable/Semester/dialogs/Dialog_TimeTableExcel';
    import Dialog_HideTeacher from '@/views/TimeTable/Semester/dialogs/Dialog_HideTeacher';
    import Dialog_ActiveTeacher from '@/views/TimeTable/Semester/dialogs/Dialog_ActiveTeacher';
    import Dialog_MonthlyTable from '@/views/TimeTable/Monthly/OperationMonthly';
    import Dialog_ClassInformation from '@/views/TimeTable/Semester/dialogs/Dialog_ClassInformation';
    import Dialog_GiveTeacherToSemester from '@/views/TimeTable/Semester/dialogs/Dialog_GiveTeacherToSemester';
    //合同
    import Dialog_InvoiceDetail from '@/views/Student/Invoice/dialogs/Dialog_InvoiceDetail';
    //其他合同
    import Dialog_AnotherInvoiceDetail from '@/views/Student/Invoice/dialogs/Dialog_AnotherInvoiceDetail';
    import Dialog_InvoiceBill from '@/views/Student/Invoice/dialogs/Dialog_InvoiceBill';
    import Dialog_LeaseInvoiceDetail from '@/views/Student/Invoice/dialogs/Dialog_LeaseInvoiceDetail';
    import Dialog_EarnestAInvoiceDetail from '@/views/Student/Invoice/dialogs/Dialog_EarnestAInvoiceDetail';
    import Dialog_EarnestBInvoiceDetail from '@/views/Student/Invoice/dialogs/Dialog_EarnestBInvoiceDetail';

    //回访详情
    import Dialog_ReturnVisitDetail from '@/views/ReturnVisit/Info/Index';
    //班主任额度
    import HistoryLimit from '@/views/HeadTeacher/Limit/components/HistoryLimit';
    import LimitDetail from '@/views/HeadTeacher/Limit/components/LimitDetail';
    import CreateLimit from '@/views/HeadTeacher/Limit/components/CreateLimit';
    //推荐人名单
    import Dialog_AddReferrerExchangePresent from '@/views/Referrer/dialogs/Dialog_AddReferrerExchangePresent';
    //权限分配
    import Dialog_AddPowerTemplate from '@/views/Authority/List/dialogs/Dialog_AddPowerTemplate';
    import Dialog_UpdatePowerTemplate from '@/views/Authority/List/dialogs/Dialog_UpdatePowerTemplate';
    import Dialog_TemplateUpdateEmployeePower from '@/views/Authority/List/dialogs/Dialog_TemplateUpdateEmployeePower';
    //学期管理
    import Dialog_GetSemesterDetail from '@/views/Semester/dialogs/Dialog_GetSemesterDetail';
    import Dialog_CreateSemester from '@/views/Semester/dialogs/Dialog_CreateSemester';
    //学校考试
    import Dialog_CreateSchoolExam from '@/views/Exam/List/widget/Dialog_CreateSchoolExam';
    //教师管理
    import Dialog_CreateTeacher from '@/views/Teacher/List/dialogs/Dialog_CreateTeacher';
    import Dialog_DeleteTeacher from '@/views/Teacher/List/dialogs/Dialog_DeleteTeacher';
    import Dialog_UpdateTeacher from '@/views/Teacher/List/dialogs/Dialog_UpdateTeacher';
    //员工详情
    import Dialog_ShowEmployeeDetail from '@/views/Employee/dialogs/Dialog_ShowEmployeeDetail'
    import Dialog_DistributionStudent from '@/views/Employee/dialogs/Dialog_DistributionStudent'
    import Dialog_StoreHeadTeacher from '@/views/Employee/dialogs/Dialog_StoreHeadTeacher'
    import Dialog_StoreSecondHeadTeacher from '@/views/Employee/dialogs/Dialog_StoreSecondHeadTeacher'
    import Dialog_DistributionSecondHeadTeacher from '@/views/Employee/dialogs/Dialog_DistributionSecondHeadTeacher'

    import Dialog_SelfSetting from '@/views/SettingDashboard/SelfSetting/Index'
    //每日课表-设置
    import Dialog_DailyTableSiteModal from '@/views/TimeTable/Daily/dialogs/Dialog_DailyTableSite'
    //每日课表-设置-日期课程互换
    import Dialog_SwapDate from '@/views/TimeTable/Daily/dialogs/Dialog_SwapDate'
    //每日课表-课堂信息
    import Dialog_ClassPlanInformation from '@/views/TimeTable/Daily/dialogs/Dialog_ClassPlanInformation'
    //每日课表-学生详情
    import Dialog_GoToStudent from '@/views/TimeTable/Daily/dialogs/Dialog_GoToStudent'
    //每日课表-查看空余教室
    import Dialog_ChooseFreeClassroom from '@/views/TimeTable/Daily/dialogs/Dialog_ChooseFreeClassroom'
    //每日课表-查看学生
    import Dialog_ChooseStudent from '@/views/TimeTable/Daily/dialogs/Dialog_ChooseStudent'
    //通知
    import Dialog_CreateMessage from '@/views/Message/dialogs/Dialog_CreateMessage'
    //创建课时管理
    import Dialog_CreateClassHour from '@/views/SettingDashboard/ClassHour/dialogs/Dialog_CreateClassHour'
    //修改课时管理
    import Dialog_GetClassHourDetail from '@/views/SettingDashboard/ClassHour/dialogs/Dialog_GetClassHourDetail'
    //创建商品
    import Dialog_CreateGoods from '@/views/SettingDashboard/Shops/dialogs/Dialog_CreateGoods'
    //修改商品
    import Dialog_UpdateGoods from '@/views/SettingDashboard/Shops/dialogs/Dialog_UpdateGoods'
    //赋予学期模板
    import Dialog_GiveTemplateToSemester from '@/views/SettingDashboard/WorkSchedule/dialogs/Dialog_GiveTemplateToSemester'
    //老师工作量数据-老师详情
    import Dialog_WorkloadDetail from '@/views/AnlyDashboard/TeacherWorkload/dialogs/Dialog_WorkloadDetail'
    //签到课表-单一签到
    import Dialog_SignLogDaily from '@/views/TimeTable/SignLogDaily/dialogs/Dialog_SignLogDaily'
    //签到课表-老师签到学生数
    import Dialog_SignCheck from '@/views/TimeTable/SignLogDaily/dialogs/Dialog_SignCheck'
    //签到课表-全部签到
    import Dialog_SignClass from '@/views/TimeTable/SignLogDaily/dialogs/Dialog_SignClass'
    //登录-修改密码
    import Dialog_ChangePassword from '@/views/User/dialogs/Dialogs_ChangePassword'
    //修改用户
    import Dialog_UpdateEmployee from '@/views/Authority/List/dialogs/Dialog_UpdateEmployee'
    //新增用户
    import Dialog_StoreEmployee from '@/views/Authority/List/dialogs/Dialog_StoreEmployee'
    //修改用户账号
    import Dialog_UpdateAccount from '@/views/Authority/List/dialogs/Dialog_UpdateAccount'
    //添加押金
    import Dialog_StoreStudentDeposit from '@/views/Deposit/dialogs/Dialog_StoreStudentDeposit'
    //电子合同
    import Dialog_BorrowingOfTeachingEquipment from '@/views/Student/DigitalContract/Dialog_BorrowingOfTeachingEquipment'
    import Dialog_TeachingEquipmentReturn from '@/views/Student/DigitalContract/Dialog_TeachingEquipmentReturn'
    import Dialog_GiftOfTeachingEquipmentForNewStudent from '@/views/Student/DigitalContract/Dialog_GiftOfTeachingEquipmentForNewStudent'
    import Dialog_GiftOfTeachingEquipment from '@/views/Student/DigitalContract/Dialog_GiftOfTeachingEquipment'
    import Dialog_RentalOfTeachingEquipmentForNewStudent from '@/views/Student/DigitalContract/Dialog_RentalOfTeachingEquipmentForNewStudent'
    //学生管理-修改学生
    import Dialog_UpdateStudent from '@/views/Student/Management/dialogs/Dialog_UpdateStudent'
    //创建教案
    import Dialog_CreateTeacherPlan from '@/views/TeacherPlan/List/dialogs/Dialog_CreateTeacherPlan'

    //创建套餐
    import Dialog_CreateClassPackage from '@/views/ClassPackage/List/dialogs/Dialog_CreateClassPackage'
    //修改套餐
    import Dialog_UpdateClassPackage from '@/views/ClassPackage/List/dialogs/Dialog_UpdateClassPackage'
    //套餐添加班级
    import Dialog_ChooseClassPackageDetail from '@/views/ClassPackage/List/dialogs/Dialog_ChooseClassPackageDetail'
    import Dialog_ChooseSpecialClassPackageDetail from '@/views/ClassPackage/List/dialogs/Dialog_ChooseSpecialClassPackageDetail'
    import Dialog_EquipmentLeasing from '@/views/Student/Show/EquipmentLeasing/Index'
    import Dialog_Earnest from '@/views/Student/Show/Earnest/Index'

    //仓库-租赁库存清单
    import Dialog_GrantShop from '@/views/Warehouse/LeaseInventoryList/dialogs/Dialog_GrantShop'
    import Dialog_LeaseInvoice from '@/views/Warehouse/LeaseInventoryList/dialogs/Dialog_LeaseInvoice'
    import Dialog_LeaseCargoShop from '@/views/Warehouse/LeaseInventoryList/dialogs/Dialog_LeaseCargoShop'
    import Dialog_LeaseDelivery from '@/views/Warehouse/LeaseInventoryList/dialogs/Dialog_LeaseDelivery'
    import Dialog_Signature from '@/views/Warehouse/LeaseInventoryList/dialogs/Dialog_Signature'

    //仓库-出租中清单
    import Dialogs_ReturnList from '@/views/Warehouse/RentingList/dialogs/Dialogs_ReturnList'
    import Dialogs_ReturnEquipment from '@/views/Warehouse/RentingList/dialogs/Dialogs_ReturnEquipment'

    //仓库-出售库存清单
    import Dialog_SellGrantShop from '@/views/Warehouse/SellInventoryList/dialogs/Dialog_SellGrantShop'
    import Dialog_SellInvoice from '@/views/Warehouse/SellInventoryList/dialogs/Dialog_SellInvoice'
    import Dialog_SellCargoShop from '@/views/Warehouse/SellInventoryList/dialogs/Dialog_SellCargoShop'
    import Dialog_SellDelivery from '@/views/Warehouse/SellInventoryList/dialogs/Dialog_SellDelivery'
    import Dialog_SellSignature from '@/views/Warehouse/SellInventoryList/dialogs/Dialog_SellSignature'

    //仓库商品列表
    import Dialogs_StoreShopName from '@/views/Warehouse/Store/List/dialogs/Dialogs_StoreShopName'
    import Dialogs_StoreWarehouse from '@/views/Warehouse/Store/List/dialogs/Dialogs_StoreWarehouse'
    import Dialogs_GetWarehouse from '@/views/Warehouse/Store/List/dialogs/Dialogs_GetWarehouse'
    import Dialogs_StoreShopMsg from  '@/views/Warehouse/Store/ShopMsgList/dialogs/Dialogs_StoreShopMsg'
    import Dialogs_GetShopMsg from  '@/views/Warehouse/Store/ShopMsgList/dialogs/Dialogs_GetShopMsg'

    //仓库-老师
    import Dialog_TeacherCargoShop from '@/views/Warehouse/TeacherDistribution/dialogs/Dialog_TeacherCargoShop'
    import Dialog_TeacherGrantShop from '@/views/Warehouse/TeacherDistribution/dialogs/Dialog_TeacherGrantShop'
    import Dialog_TeacherShopList from '@/views/Warehouse/TeacherDistribution/dialogs/Dialog_TeacherShopList'

    //学生组团
    import Dialogs_AddNewTeam from '@/views/StudentTeam/dialogs/Dialogs_AddNewTeam'
    import Dialogs_TeamAddStudent from '@/views/StudentTeam/dialogs/Dialogs_TeamAddStudent'


    export default {
        data() {
            return {
                name: "",
            };
        },
        components: {
            //学生详情
            'Dialog_ChooseClass': Dialog_ChooseClass,
            'Dialog_ChooseSpecialClass': Dialog_ChooseSpecialClass,
            'Dialog_ChangeInformation': Dialog_ChangeInformation,
            'Dialog_ChangeStudentPhone': Dialog_ChangeStudentPhone,
            //学生详情-课程咨询
            'Dialog_AddAdvisory': Dialog_AddAdvisory,
            'Dialog_ShowAdvisory': Dialog_ShowAdvisory,
            //学生详情-课程记录
            'Dialog_CancelCourse': Dialog_CancelCourse,
            'Dialog_ChangeCourse': Dialog_ChangeCourse,
            'Dialog_StudentCourseEvaluation': Dialog_StudentCourseEvaluation,
            //学生详情-课程购买
            'Dialog_ChooseClassPlan': Dialog_ChooseClassPlan,
            'Dialog_ChooseCoupon': Dialog_ChooseCoupon,
            'Dialog_ChooseLesson': Dialog_ChooseLesson,
            'Dialog_ChooseWanTuoClassPlan': Dialog_ChooseWanTuoClassPlan,
            'Dialog_DiscountCourse': Dialog_DiscountCourse,
            'Dialog_DiscountType': Dialog_DiscountType,
            'Dialog_HasTime': Dialog_HasTime,
            'Dialog_Installment': Dialog_Installment,
            'Dialog_InvoiceDetail': Dialog_InvoiceDetail,
            'Dialog_LeaseInvoiceDetail': Dialog_LeaseInvoiceDetail,
            'Dialog_EarnestAInvoiceDetail':Dialog_EarnestAInvoiceDetail,
            'Dialog_EarnestBInvoiceDetail':Dialog_EarnestBInvoiceDetail,
            'Dialog_AnotherInvoiceDetail':Dialog_AnotherInvoiceDetail,
            'Dialog_InvoiceBill': Dialog_InvoiceBill,
            'Dialog_SettleAccounts': Dialog_SettleAccounts,
            'Dialog_SettleSuccess':Dialog_SettleSuccess,
            //学生详情-课程购买-使用课次
            'Dialog_UseClassHour': Dialog_UseClassHour,
            //学生详情-购买课次
            'Dialog_ClassHourCart':Dialog_ClassHourCart,
            //学生详情-显示试听购物车
            'Dialog_TryingCart':Dialog_TryingCart,
            //学生详情-打折课次
            'Dialog_DiscountClassHour':Dialog_DiscountClassHour,
            //学生详情-购买商品
            'Dialog_ShopCart':Dialog_ShopCart,
            //学生详情-打折商品
            'Dialog_DiscountShop':Dialog_DiscountShop,
            //课次商品结算
            'Dialog_SettleAnotherAccounts':Dialog_SettleAnotherAccounts,
            //学生详情-钱包
            'Dialog_LessonRetired': Dialog_LessonRetired,
            'Dialog_WalletAddCash': Dialog_WalletAddCash,
            'Dialog_ClassHourRetired':Dialog_ClassHourRetired,
            'Dialog_UpdateCashCoupon':Dialog_UpdateCashCoupon,
            //学生详情-教育经历
            'Dialog_StudentAddEducationalExperiences': Dialog_StudentAddEducationalExperiences,
            'Dialog_StudentEducationalExperiencesDetail': Dialog_StudentEducationalExperiencesDetail,
            'Dialog_BalanceDetail': Dialog_BalanceDetail,
            //学生详情-学校成绩
            'Dialog_AddSchoolScore': Dialog_AddSchoolScore,
            'Dialog_UpdateMainSchoolScore': Dialog_UpdateMainSchoolScore,
            //学生详情-回访
            'Dialog_PastReturnDetail': Dialog_PastReturnDetail,
            //学生详情-在读课程概况
            'Dialog_ChangeClassPlan': Dialog_ChangeClassPlan,
            //学生详情-周课表
            'Dialog_StudentWeekTable': Dialog_StudentWeekTable,
            //学生详情-月课表
            'Dialog_StudentMonthTable': Dialog_StudentMonthTable,
            //课表
            'Dialog_UpdateClass': Dialog_UpdateClass,
            'Dialog_UpdateClass_Semester': Dialog_UpdateClass_Semester,
            'Dialog_CreateClass_Semester': Dialog_CreateClass_Semester,
            'Dialog_MonthlyTable': Dialog_MonthlyTable,
            //课表-课程信息
            'Dialog_ClassInformation':Dialog_ClassInformation,
            //学期赋予老师
            'Dialog_GiveTeacherToSemester':Dialog_GiveTeacherToSemester,
            //回访详情
            'Dialog_ReturnVisitDetail': Dialog_ReturnVisitDetail,
            //班主任额度
            'HistoryLimit': HistoryLimit,
            'LimitDetail': LimitDetail,
            'CreateLimit': CreateLimit,
            //推荐人名单
            'Dialog_AddReferrerExchangePresent': Dialog_AddReferrerExchangePresent,
            //权限分配
            'Dialog_AddPowerTemplate': Dialog_AddPowerTemplate,
            'Dialog_UpdatePowerTemplate': Dialog_UpdatePowerTemplate,
            'Dialog_TemplateUpdateEmployeePower': Dialog_TemplateUpdateEmployeePower,
            //学期管理
            'Dialog_GetSemesterDetail': Dialog_GetSemesterDetail,
            'Dialog_CreateSemester': Dialog_CreateSemester,
            //学校考试
            'Dialog_CreateSchoolExam': Dialog_CreateSchoolExam,
            //学期课表
            'Dialog_TableSiteModal': Dialog_TableSiteModal,
            'Dialog_TimeTableExcel': Dialog_TimeTableExcel,
            'Dialog_HideTeacher': Dialog_HideTeacher,
            'Dialog_ActiveTeacher': Dialog_ActiveTeacher,
            //教师管理
            'Dialog_CreateTeacher': Dialog_CreateTeacher,
            'Dialog_DeleteTeacher': Dialog_DeleteTeacher,
            'Dialog_UpdateTeacher': Dialog_UpdateTeacher,
            //员工管理
            'Dialog_ShowEmployeeDetail': Dialog_ShowEmployeeDetail,
            'Dialog_DistributionStudent': Dialog_DistributionStudent,
            'Dialog_StoreHeadTeacher': Dialog_StoreHeadTeacher,
            'Dialog_StoreSecondHeadTeacher': Dialog_StoreSecondHeadTeacher,
            'Dialog_DistributionSecondHeadTeacher': Dialog_DistributionSecondHeadTeacher,
            //个人设置
            'Dialog_SelfSetting': Dialog_SelfSetting,
            //发送通知
            'Dialog_CreateMessage': Dialog_CreateMessage,
            //每日课表-设置
            'Dialog_DailyTableSiteModal':Dialog_DailyTableSiteModal,
            //每日课表-设置-日期课程互换
            'Dialog_SwapDate':Dialog_SwapDate,
            //每日课表-课堂信息
            'Dialog_ClassPlanInformation':Dialog_ClassPlanInformation,
            //每日课表-学生详情
            'Dialog_GoToStudent':Dialog_GoToStudent,
            //每日课表-查看空余教室
            'Dialog_ChooseFreeClassroom':Dialog_ChooseFreeClassroom,
            //每日课表-查看学生
            'Dialog_ChooseStudent':Dialog_ChooseStudent,
            //课时管理创建
            'Dialog_CreateClassHour':Dialog_CreateClassHour,
            //课时管理修改
            'Dialog_GetClassHourDetail':Dialog_GetClassHourDetail,
            //创建商品
            'Dialog_CreateGoods':Dialog_CreateGoods,
            //修改商品
            'Dialog_UpdateGoods':Dialog_UpdateGoods,
            //赋予学期模板
            'Dialog_GiveTemplateToSemester':Dialog_GiveTemplateToSemester,
            //老师工作量数据-老师详情
            'Dialog_WorkloadDetail':Dialog_WorkloadDetail,
            //签到课表-单一签到
            'Dialog_SignLogDaily':Dialog_SignLogDaily,
            //签到课表-老师签到学生
            'Dialog_SignCheck':Dialog_SignCheck,
            //签到课表-全部签到
            'Dialog_SignClass':Dialog_SignClass,
            //登录-修改密码
            'Dialog_ChangePassword':Dialog_ChangePassword,
            //修改用户
            'Dialog_UpdateEmployee':Dialog_UpdateEmployee,
            //新增用户
            'Dialog_StoreEmployee':Dialog_StoreEmployee,
            //修改用户账号
            'Dialog_UpdateAccount':Dialog_UpdateAccount,
            //添加押金
            'Dialog_StoreStudentDeposit':Dialog_StoreStudentDeposit,
            //电子合同
            'Dialog_BorrowingOfTeachingEquipment':Dialog_BorrowingOfTeachingEquipment,
            'Dialog_TeachingEquipmentReturn':Dialog_TeachingEquipmentReturn,
            'Dialog_GiftOfTeachingEquipmentForNewStudent':Dialog_GiftOfTeachingEquipmentForNewStudent,
            'Dialog_GiftOfTeachingEquipment':Dialog_GiftOfTeachingEquipment,
            'Dialog_RentalOfTeachingEquipmentForNewStudent':Dialog_RentalOfTeachingEquipmentForNewStudent,
            //学生管理-修改学生
            'Dialog_UpdateStudent':Dialog_UpdateStudent,
            //创建教案
            'Dialog_CreateTeacherPlan':Dialog_CreateTeacherPlan,
            //创建套餐
            'Dialog_CreateClassPackage':Dialog_CreateClassPackage,
            'Dialog_UpdateClassPackage':Dialog_UpdateClassPackage,
            'Dialog_ChooseClassPackageDetail':Dialog_ChooseClassPackageDetail,
            'Dialog_ChooseSpecialClassPackageDetail':Dialog_ChooseSpecialClassPackageDetail,
            //未结算合同-订单详情
            'Dialog_SettlementInvoiceDetail':Dialog_SettlementInvoiceDetail,
            //商品租赁
            'Dialog_EquipmentLeasing':Dialog_EquipmentLeasing,
            //定金支付
            'Dialog_Earnest':Dialog_Earnest,
            //仓库-租赁库存清单
            'Dialog_GrantShop':Dialog_GrantShop,
            'Dialog_LeaseInvoice':Dialog_LeaseInvoice,
            'Dialog_LeaseCargoShop':Dialog_LeaseCargoShop,
            'Dialog_LeaseDelivery':Dialog_LeaseDelivery,
            'Dialog_Signature':Dialog_Signature,

            'Dialogs_ReturnList':Dialogs_ReturnList,
            'Dialogs_ReturnEquipment':Dialogs_ReturnEquipment,
            //仓库-出售库存清单
            'Dialog_SellGrantShop':Dialog_SellGrantShop,
            'Dialog_SellInvoice':Dialog_SellInvoice,
            'Dialog_SellCargoShop':Dialog_SellCargoShop,
            'Dialog_SellDelivery':Dialog_SellDelivery,
            'Dialog_SellSignature':Dialog_SellSignature,

            //仓库商品列表
            'Dialogs_StoreShopName':Dialogs_StoreShopName,
            'Dialogs_StoreWarehouse':Dialogs_StoreWarehouse,
            'Dialogs_GetWarehouse':Dialogs_GetWarehouse,
            'Dialogs_StoreShopMsg':Dialogs_StoreShopMsg,
            'Dialogs_GetShopMsg':Dialogs_GetShopMsg,

            //仓库-老师
            'Dialog_TeacherShopList':Dialog_TeacherShopList,
            'Dialog_TeacherCargoShop':Dialog_TeacherCargoShop,
            'Dialog_TeacherGrantShop':Dialog_TeacherGrantShop,

            //学生组团
            'Dialogs_AddNewTeam':Dialogs_AddNewTeam,
            'Dialogs_TeamAddStudent':Dialogs_TeamAddStudent,
    },
        methods: {
            handleClose() {
                if(this.$store.state.modal.closeJudge){
                    this.$confirm('确认关闭？')
                        .then(_ => {
                            this.$store.commit('modalClose');
                        })
                        .catch(_ => {});
                }else{
                    this.$store.commit('modalClose');
                }
            }
        }
    };
</script>
